export default "/_next/static/images/d2d776157b8209283e8fdd8c5954b7c2.jpg";